/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Kennzahl ueber die einem Eintrag zugeordneten Datensaetze einer Unterdatenbank (Zuordnung ueber `belongsTo`).
 * @export
 * @interface DatabaseCalcFieldAggregate
 */
export interface DatabaseCalcFieldAggregate {
    /**
     * Unterdatenbank, deren zugeordnete Datensaetze ausgewertet werden.
     * @type {string}
     * @memberof DatabaseCalcFieldAggregate
     */
    childDatabaseId?: string;
    /**
     * Feld in der Unterdatenbank, das ausgewertet wird.
     * @type {string}
     * @memberof DatabaseCalcFieldAggregate
     */
    fieldId?: string;
    /**
     * SUM/AVERAGE nur fuer Zahl, Waehrung, Prozent und Berechnung. FIRST gilt fuer jeden Feldtyp und nimmt den Datensatz, der in der manuellen Sortierung ganz oben steht (kleinster `rank`).
     * @type {string}
     * @memberof DatabaseCalcFieldAggregate
     */
    aggregateFunction?: DatabaseCalcFieldAggregateAggregateFunctionEnum;
    /**
     * ZAEHLEN UEBER FELDER DESSELBEN DATENSATZES — statt ueber die
     * zugeordneten Datensaetze einer Unterdatenbank.
     * 
     * WOFUER: Der Ass-Zaehler der Scorecard. „Wie oft hat dieser Spieler
     * eine 1 geschlagen?" stand als Beispiel schon bei `countValue` —
     * aber die Schlaege liegen nicht als 18 DATENSAETZE vor, sondern als
     * 18 FELDER an einem Spieler-Datensatz („Bahn 1" … „Bahn 36").
     * `childDatabaseId` fuehrt da nicht hin.
     * 
     * Steht hier eine Feldliste, wird IN DIESEM Datensatz gezaehlt und
     * `childDatabaseId` ignoriert. Dieselbe Form, die der Zaehler-
     * Baustein schon kennt (`inputFieldIds`).
     * 
     * Erprobt und verworfen wurde die Kette
     * `WENN(Bahn 1 = 1) DANN 1 SONST 0` + … : Sie summiert nicht,
     * sondern liefert 1, sobald irgendwo eine 1 steht.
     * @type {Array<string>}
     * @memberof DatabaseCalcFieldAggregate
     */
    fieldIds?: Array<string>;
    /**
     * Nur bei COUNT_VALUE: der Wert, dessen Vorkommen gezaehlt werden.
     * WOFUER: „Wie oft hat dieser Spieler eine 1 geschlagen?" ist keine Summe und kein Durchschnitt -- es ist eine Zaehlung. Ohne sie musste man eine WENN-Kette ueber jede einzelne Bahn bauen; die zaehlt nicht, sondern rechnet, und bei achtzehn Bahnen ist sie weder schreibbar noch pruefbar.
     * Verglichen wird zahlbewusst: Wo BEIDE Seiten Zahlen sind, gilt der Zahlwert (1 und 1,0 sind dasselbe), sonst der getrimmte Text ohne Ruecksicht auf Gross- und Kleinschreibung. Sonst zaehlte „Ja" anders als „ja", und niemand saehe warum.
     * @type {string}
     * @memberof DatabaseCalcFieldAggregate
     */
    countValue?: string;
    /**
     * DER RUECKWEG. Ohne diese Angabe zaehlen die Datensaetze, die dem Eintrag ZUGEORDNET sind (`belongsTo`) -- der Normalfall einer Unterdatenbank. Mit ihr zaehlen stattdessen die Datensaetze, die ueber DIESES Verweisfeld (`ENTRY_LINK_FIELD`) auf den Eintrag zeigen. `childDatabaseId` ist dann die Datenbank, in der die verweisenden Datensaetze liegen.
     * WOFUER: Ein Sprint soll den Restaufwand seiner Tickets summieren. Die Tickets sind aber keine Unterdatenbank des Sprints -- sie zeigen auf ihn, und sie existieren auch ohne Sprint (Themenspeicher, Planung). Ohne den Rueckweg muesste man die Hierarchie umkehren und die Ticket-Datenbank unter die Sprints haengen.
     * @type {string}
     * @memberof DatabaseCalcFieldAggregate
     */
    viaLinkFieldId?: string;
}


/**
 * @export
 */
export const DatabaseCalcFieldAggregateAggregateFunctionEnum = {
    Sum: 'SUM',
    Average: 'AVERAGE',
    First: 'FIRST',
    Count: 'COUNT',
    CountValue: 'COUNT_VALUE'
} as const;
export type DatabaseCalcFieldAggregateAggregateFunctionEnum = typeof DatabaseCalcFieldAggregateAggregateFunctionEnum[keyof typeof DatabaseCalcFieldAggregateAggregateFunctionEnum];


/**
 * Check if a given object implements the DatabaseCalcFieldAggregate interface.
 */
export function instanceOfDatabaseCalcFieldAggregate(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseCalcFieldAggregateFromJSON(json: any): DatabaseCalcFieldAggregate {
    return DatabaseCalcFieldAggregateFromJSONTyped(json, false);
}

export function DatabaseCalcFieldAggregateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseCalcFieldAggregate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'childDatabaseId': !exists(json, 'childDatabaseId') ? undefined : json['childDatabaseId'],
        'fieldId': !exists(json, 'fieldId') ? undefined : json['fieldId'],
        'aggregateFunction': !exists(json, 'aggregateFunction') ? undefined : json['aggregateFunction'],
        'fieldIds': !exists(json, 'fieldIds') ? undefined : json['fieldIds'],
        'countValue': !exists(json, 'countValue') ? undefined : json['countValue'],
        'viaLinkFieldId': !exists(json, 'viaLinkFieldId') ? undefined : json['viaLinkFieldId'],
    };
}

export function DatabaseCalcFieldAggregateToJSON(value?: DatabaseCalcFieldAggregate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'childDatabaseId': value.childDatabaseId,
        'fieldId': value.fieldId,
        'aggregateFunction': value.aggregateFunction,
        'fieldIds': value.fieldIds,
        'countValue': value.countValue,
        'viaLinkFieldId': value.viaLinkFieldId,
    };
}

